<template>
    <div>
        <b-carousel
            id="carousel"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            fade
            class="font-weight-bold mt-3"
            style="text-shadow: 0px 0px 2px #000"
            img-width="1024"
            img-height="500"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
            <b-carousel-slide
                v-for="item in chartData"
                :key="item.id"
                :caption="item.event.name"
                img-blank-color="#962934"
                img-blank>

                <div class="">
                    {{ item.date | moment('DD/MM/YYYY') }}
                </div>

                <div>
                    <i>
                        {{ item.description }}
                    </i>
                </div>

                <div class="">
                    {{ item.result | currency(symbol) }}
                </div>

            </b-carousel-slide>
        </b-carousel>
    </div>
</template>

<script>
export default {
    props: ['chartData', 'currency', 'symbol'],

    data() {
        return {
            slide: 0,
            sliding: null
        }
    },

    methods: {

        onSlideStart(slide) {
            this.sliding = true
        },

        onSlideEnd(slide) {
            this.sliding = false
        }

    }
}
</script>

<style scoped>

</style>
